import { useEffect, useRef, useState } from "react";

export const useReveal = (options = { threshold: 0.1, rootMargin: "0px 0px -10% 0px" }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    // Safety fallback: ensure visibility after 1.2s even if observer doesn't fire
    const timeout = setTimeout(() => setVisible(true), 1200);
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setVisible(true);
            obs.unobserve(node);
            clearTimeout(timeout);
          }
        });
      },
      options
    );
    obs.observe(node);
    return () => {
      obs.disconnect();
      clearTimeout(timeout);
    };
  }, [options]);

  return { ref, visible };
};
